import React from "react";
import PropTypes from "prop-types";
import {useTranslation} from "react-i18next";
import LinkedIncidents from "./LinkedIncidents";
import Source from "./Source";
import Timestamp from "./Timestamp";

const ReportedBy = ({
  incident,
  displayRelativeTime,
  hideLinkedIncidents = false,
  ...rest
}) => {
  const {source, source_uri, incident_time} = incident;
  const {t} = useTranslation();

  return (
    <div data-testid={"ReportedBy-Container"} {...rest}>
      {t("incidentDetail.detail.reported")}
      <Source source={source} source_uri={source_uri} />
      <Timestamp {...{incident_time, displayRelativeTime}} />
      {!hideLinkedIncidents && <LinkedIncidents />}
    </div>
  );
};

ReportedBy.propTypes = {
  className: PropTypes.string,
  /**
   * If true, date will be displayed in relative time from now
   *
   * @example "2 days ago"
   *
   * @defaultValue false
   */
  displayRelativeTime: PropTypes.bool,
  /**
   * If false, count of Linked Incidents will show with link to open drawer will
   * be hidden
   *
   * @defaultValue false
   */
  hideLinkedIncidents: PropTypes.bool
};

export default ReportedBy;
